import requests from "./httpService";

const PurchaseServices = {

    getPurchase: async () =>{
        return requests.get(`/purchase/report`);
    },
   
    addPurchase : async (body) =>{
        return requests.post(`/purchase/add`,body);
    },

    deletePurchases : async (id) =>{
        return requests.delete(`/purchase/${id}`);
    },
  
    updatePurchases : async (id,body) =>{
        return requests.patch(`purchase/purchase/${id}`,body);
    },
   
}
export default PurchaseServices;